import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

export interface Client {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  householdId: string;
  isPrimary: boolean;
}

export const toClient = (c: components["schemas"]["ClientOut"]): Client => ({
  id: c.uuid,
  name: c.name,
  email: c.email,
  phone: c.phone,
  householdId: c.household_uuid,
  isPrimary: c.is_primary,
});

export const fetchClient = (id: string): Promise<Client> =>
  request(() =>
    apiClient.GET("/clients/{client_uuid}", {
      params: { path: { client_uuid: id } },
    }),
  ).then(toClient);
